import { campaignBillingStatus } from 'constants/campaignConstants';
import { parseAdmin } from 'services/adminServices';
import { parseArtDesignsRequest } from 'services/campaignArtServices';
import { parseBilling, parseCampaign } from 'services/campaignServices';

import { axiosWithToken } from './axios';

export const fetchGetCampaigns = async (
  { page, perPage, name, campaignStatus, billingStatus, cancelToken } = {
    page: null,
    perPage: null,
    name: '',
    campaignStatus: '',
    billingStatus: '',
  }
) => {
  const params = {
    page,
    per_page: perPage,
    name,
    campaign_status: campaignStatus,
    billing_status: billingStatus,
  };

  const response = await axiosWithToken.get(`campaign`, {
    params,
    cancelToken,
  });

  const {
    art_change_requests: artChangeRequests,
    campaigns,
    totalCount,
    totalPages,
  } = JSON.parse(response.data.body);

  return {
    artChangeRequests: artChangeRequests.map((el) =>
      parseArtDesignsRequest(el)
    ),
    campaigns: campaigns.map((campaign) => parseCampaign(campaign)),
    totalCount,
    totalPages,
  };
};

export const fetchGetCampaign = async ({ id }) => {
  const response = await axiosWithToken.get(`campaign`, {
    params: { id },
  });

  const { campaigns } = JSON.parse(response.data.body);

  return campaigns.map((campaign) => parseCampaign(campaign))[0];
};

export const fetchAddCampaign = async (data) => {
  const response = await axiosWithToken.post('campaign', data);

  const { campaign } = JSON.parse(response.data.body);

  return parseCampaign(campaign);
};

export const fetchEditCampaign = async (data) => {
  const response = await axiosWithToken.post('campaign', data);

  const { campaign } = JSON.parse(response.data.body);

  return parseCampaign(campaign);
};

export const fetchGetCampaignAdmins = async ({ campaignId }) => {
  const response = await axiosWithToken.get('campaign/assign', {
    params: {
      campaign_id: campaignId,
    },
  });

  const { result: admins } = JSON.parse(response.data.body);

  return admins.map((admin) => parseAdmin(admin));
};

export const fetchGetCampaignBilling = async ({ campaignId }) => {
  const response = await axiosWithToken.get('campaign/ledger', {
    params: {
      campaign_id: campaignId,
    },
  });

  const { ledger } = response.data;

  return ledger.map((billing) => parseBilling(billing));
};

export const fetchCancelSubscription = async (data) => {
  const response = await axiosWithToken.post('campaign/cancel-billing', data);

  const { campaign_status: campaignStatus } = JSON.parse(response.data.body);

  return campaignStatus;
};

export const fetchCalculateCampaignPricing = async (data) => {
  const response = await axiosWithToken.post('campaign/recalc', data);

  return JSON.parse(response.data.body);
};

export const fetchFailedCampaignPayments = async () => {
  const response = await axiosWithToken.get(`campaign`, {
    params: { perPage: 1, billing_status: campaignBillingStatus.FAILED },
  });

  const { campaigns } = JSON.parse(response.data.body);

  return campaigns.length > 0;
};

export const fetchGetCampaignStatuses = async () => {
  const response = await axiosWithToken.get('campaign/status-map');

  const { statusMap: statuses } = JSON.parse(response.data.body);

  return Object.keys(statuses).map((key) => {
    return { id: Number(key), label: statuses[key] };
  });
};
